/* global axios */
import ApiClient from './ApiClient';

class PersonalCannedResponse extends ApiClient {
  constructor() {
    super('personal_canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }
}

export default new PersonalCannedResponse();
